import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { R400 } from '@atlaskit/theme/colors';
import { ApiErrorType } from '@atlassian/proforma-common-core/jira-common-models';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { projectTypeLowerCase } from '../../../services/projects';
import { getMessage } from '../form-validation-result-message';
import { messages } from './messages';
export const getFormValidationResultMessage = (apiError, project, formDetails, intl, push, showFlag, createAnalyticsEvent, userIsProjectAdmin, showFormLoadingFailedFlag = true) => {
  if (isUnknownApiError(apiError) && apiError.status === 409) {
    const message = getMessage(apiError.responseJson, formDetails, project.key, projectTypeLowerCase(project), project.simplified, formDetails.projectFormId, intl, push, createAnalyticsEvent, userIsProjectAdmin);
    if (message) {
      return message;
    }
  }
  if (showFormLoadingFailedFlag) {
    showFlag({
      icon: /*#__PURE__*/React.createElement(ErrorIcon, {
        label: "error",
        primaryColor: `var(--ds-icon-danger, ${R400})`
      }),
      id: 'form-load-error',
      title: /*#__PURE__*/React.createElement(FormattedMessage, messages.formLoadingFailedFlagTitle),
      description: /*#__PURE__*/React.createElement(FormattedMessage, messages.formLoadingFailedFlagDescription)
    });
  }
  return undefined;
};
const isUnknownApiError = apiError => apiError.error === ApiErrorType.unknown;